import { useState, useCallback } from "react";
import * as api from "../api";

// Datos de las integraciones (Notion y Microsoft): lo sincronizado, la lista de
// conexiones y las acciones que lo refrescan. La carga inicial y el reloj de
// Outlook los sigue haciendo App, que es quien sabe cuando hay sesion.
export function useIntegraciones(showToast) {
  const [notionItems,   setNotionItems  ] = useState([]);
  const [outlookEvents, setOutlookEvents] = useState([]);
  const [integrations,  setIntegrations ] = useState([]);

  // ── Reload integration data after connecting ───────────────────────────────
  const reloadIntegrations = useCallback(() => {
    api.getIntegrations().then(d => { if(Array.isArray(d)) setIntegrations(d); }).catch(()=>{});
    // Un fallo aqui NO es "no hay nada sincronizado": callarlo pintaba una
    // pantalla vacia que parecia un workspace vacio, y a buscar por otro lado.
    api.getNotionItems()
      .then(d => { if(Array.isArray(d)) setNotionItems(d); })
      .catch(e => showToast(`No se pudieron cargar los elementos de Notion: ${e.message}`, "error"));
    api.getOutlookEvents().then(d => { if(Array.isArray(d)) setOutlookEvents(d); }).catch(()=>{});
  }, []); // eslint-disable-line

  const syncNotion = async () => {
    try {
      const result = await api.syncNotion();
      // Refresca items + integraciones (para actualizar la fecha de sincronización)
      reloadIntegrations();
      const parts = [];
      if (result?.synced != null) parts.push(`${result.synced} elemento${result.synced === 1 ? "" : "s"}`);
      if (result?.pruned)         parts.push(`${result.pruned} eliminado${result.pruned === 1 ? "" : "s"}`);
      showToast(`Notion sincronizado${parts.length ? ` (${parts.join(", ")})` : ""}`);
    } catch (e) {
      showToast(e.message || "Error al sincronizar Notion", "error");
    }
  };

  // Refleja en memoria un item de Notion editado desde la pestana Proyectos,
  // sin esperar a una sincronizacion completa.
  const upsertNotionItem = useCallback((item) => {
    if (!item) return;
    setNotionItems(items => {
      const i = items.findIndex(x => x.external_id === item.external_id);
      if (i === -1) return [...items, item];
      const next = [...items];
      next[i] = { ...next[i], ...item };
      return next;
    });
  }, []);

  const removeNotionItem = useCallback((externalId) => {
    setNotionItems(items => items.filter(x => x.external_id !== externalId));
  }, []);

  const syncMicrosoft = async () => {
    const result = await api.syncOutlook();
    api.getOutlookEvents().then(d => { if(Array.isArray(d)) setOutlookEvents(d); }).catch(()=>{});
    showToast(`Calendario sincronizado${result?.synced != null ? ` (${result.synced} eventos)` : ""}`);
    return result;
  };

  const handleIntegrationSync = async (provider) => {
    if (provider === "notion") return syncNotion();
    if (provider === "microsoft") return syncMicrosoft();
  };

  return {
    notionItems, setNotionItems, outlookEvents, setOutlookEvents, integrations, setIntegrations,
    reloadIntegrations, syncNotion, upsertNotionItem, removeNotionItem, syncMicrosoft, handleIntegrationSync,
  };
}
